import React from "react";

export default function DmwfComponent() {
  return (
    <div className="about_area pt-45">
      <div className="container">
        <div className="row">
          

          {/* Text Content Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3">
              
              <div className="section_main_title text-left">
                <h1>The Key GTM Insight from DMWF Europe: Visibility Beats Volume
                </h1>
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
             
            </div>

            <div className="singel_about_left mb-30">
              <div className="singel_about_left_inner mb-3">
                <div className="singel-about-content text-left">
                    <p><a href="https://www.digitalmarketing-conference.com/">DMWF</a> Europe reinforced one clear message: modern GTM success isn’t about doing more marketing. It’s about acting at the right moment.
</p>
                <p>
                Across conversations at Stand #168, revenue and marketing teams shared a common challenge. A pipeline exists, but visibility into who is about to act is still missing.
                </p>
                  <p>
                 That’s where Renewal Intelligence changes the equation.

                  </p>
                 
                </div>
              </div>

              
            </div>
          </div>
          {/* Image Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="about_thumb">
              <img src="/assets/images/dmwf-post-event.png" alt="DMWF event" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
